import { render, staticRenderFns } from "./TopVendorRejectedDelivery.vue?vue&type=template&id=f3f805bc&scoped=true&"
import script from "./TopVendorRejectedDelivery.vue?vue&type=script&lang=js&"
export * from "./TopVendorRejectedDelivery.vue?vue&type=script&lang=js&"
import style0 from "./TopVendorRejectedDelivery.vue?vue&type=style&index=0&id=f3f805bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f805bc",
  null
  
)

export default component.exports